exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".edit_wrap[data-v-0f824512]{margin:50px auto;width:1050px;border:1px solid #eee}.pic_skan[data-v-0f824512]{margin-top:5px;box-sizing:border-box;margin-top:10px;margin-right:5px;width:150px;height:150px;border:1px solid #c0ccda;border-radius:6px;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-0f824512","scoped":true,"hasInlineConfig":false}!./~/less-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/modules/supplierInfo/brandSupplement.vue
// module id = 337
// module chunks = 0